  document.addEventListener("DOMContentLoaded", function () {

    const swiper = new Swiper('.swiper.upsell-slider', {
      slidesPerView: 8,
      spaceBetween: 10,
      loop: false,
      navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
      }
    });

    const upsellItems = document.querySelectorAll('.upsell-item');
    const titleElement = document.getElementById('active-pattern-title');
    
    upsellItems.forEach(item => {
      const originalTitle = titleElement.textContent;

       item.addEventListener('mouseenter', function () {
        const dataTitle = item.querySelector('a').getAttribute('data-title');
        const firstWord = dataTitle.split(" ")[0];
        titleElement.textContent = firstWord;
      });

      item.addEventListener('mouseleave', function () {
        titleElement.textContent = originalTitle;
      });
    });

     var orderSwatch= document.querySelector('.order-swatch');
     if(orderSwatch){
         orderSwatch.addEventListener('click', function(event) {
          event.preventDefault();

          let swatchOption = document.querySelector('input[type="radio"][data-value="10_x_10"]');
          if (swatchOption) {
              swatchOption.checked = true;
              swatchOption.dispatchEvent(new Event('change', { bubbles: true }));
              setTimeout(() => {
                  let addToCartButton = document.querySelector('form[action$="/cart/add"] button[type="submit"], .add-to-cart');
                  if (addToCartButton) {
                      addToCartButton.click();
                  }
              }, 100);
          }
      });
     }
  });